import { commonRegx } from "xcommon-node/src/common/commonRegx";
import { EntityConditionImple } from "../entity/EntityConditionImple";

export class DtoConditionsPostReqImple extends EntityConditionImple {
  public IsValid(): string[] {
    let res: string[] = new Array();
    //単項目チェック
    //--------------

    return res;
  }
}
